// Reads the current Lexical selection and returns which formats are active.
// Must be called inside editorState.read() or editor.update().

import {
  $getSelection,
  $isRangeSelection,
  BaseSelection,
  type LexicalNode,
} from "lexical";
import { $isHeadingNode } from "@lexical/rich-text";
import { $isListItemNode, $isListNode } from "@lexical/list";

import type { ActiveFormats } from "./types";
import { DEFAULT_ACTIVE_FORMATS } from "./types";

export const getActiveFormats = (): ActiveFormats => {
  const selection: BaseSelection | null = $getSelection();
  if (!selection || !$isRangeSelection(selection)) {
    return DEFAULT_ACTIVE_FORMATS;
  }

  const anchorNode: LexicalNode = selection.anchor.getNode();
  const topLevelElement: LexicalNode | null = anchorNode.getTopLevelElement();
  if (!topLevelElement) {
    return DEFAULT_ACTIVE_FORMATS;
  }

  return {
    heading:
      $isHeadingNode(topLevelElement) && topLevelElement.getTag() === "h2",
    bold: selection.hasFormat("bold"),
    list: $isListItemNode(topLevelElement) || $isListNode(topLevelElement),
  };
};
